import React from "react";
import { Flex, Typography } from "antd";
import arrowUp from "images/arrow-up-red.svg";
import arrowDown from "images/arrow-down-green.svg";
import transferIcon from "images/arrow-bend-down-left.svg";
import feeIcon from "images/coins-stack.svg";
import lockIcon from "images/rub-operations/icon-lock.svg";
import unlockIcon from "images/rub-operations/icon-unlock.svg";
import lockWithdrawalIcon from "images/rub-operations/icon-lock-withdrawal.svg";
import unlockWithdrawalIcon from "images/rub-operations/icon-unlock-withdrawal.svg";
import styles from "./operationTypeIcon.module.css";
import { RUB_OPERATION_TYPE_ENUM, RUB_OPERATION_TYPE_TEXT_OPERATOR, RUB_OPERATION_TYPE_TEXTS } from "interfaces";

interface OperationTypeIconProps {
  type: RUB_OPERATION_TYPE_ENUM;
  isOperator: boolean;
}

const typeIcon = {
  [RUB_OPERATION_TYPE_ENUM.IN]: arrowDown,
  [RUB_OPERATION_TYPE_ENUM.OUT]: arrowUp,
  [RUB_OPERATION_TYPE_ENUM.TRANSFER_IN]: transferIcon,
  [RUB_OPERATION_TYPE_ENUM.TRANSFER_OUT]: transferIcon,
  [RUB_OPERATION_TYPE_ENUM.FEE]: feeIcon,
  [RUB_OPERATION_TYPE_ENUM.LOCK]: lockIcon,
  [RUB_OPERATION_TYPE_ENUM.UNLOCK]: unlockIcon,
  [RUB_OPERATION_TYPE_ENUM.LOCK_WITHDRAWAL]: lockWithdrawalIcon,
  [RUB_OPERATION_TYPE_ENUM.UNLOCK_WITHDRAWAL]: unlockWithdrawalIcon,
};

export const OperationTypeIcon: React.FC<OperationTypeIconProps> = ({ type, isOperator }) => {
  return (
    <Flex align="center" gap={10}>
      <Flex vertical className="square icon-3xl bg-basic-200">
        <img src={typeIcon[type]} alt={type} />
      </Flex>
      <Typography.Text type="secondary" className={styles.operationTypeIconLabel}>
        {isOperator ? RUB_OPERATION_TYPE_TEXT_OPERATOR[type] : RUB_OPERATION_TYPE_TEXTS[type]}
      </Typography.Text>
    </Flex>
  );
};
